import { Monsters } from "./Monsters";

/*
    Arc is a list of Levels
*/
export default class Arc {
    public Name: string;
    public Icon: string;
    public MapAreaX: number;
    public MapAreaY: number;
    public ConfigFolder: string;
    public LevelConfigs: ArcLevelConfig[];
}

export type ArcLevelConfig = {
    ConfigurationFile: string,
    CoverImage: string,
    MapAreaX: number,
    MapAreaY: number
};

export class Arcs {

    static Arcs: Arc[];
    static Created: boolean = false;
    static Preloaded: boolean = false;

    static preload(scene: Phaser.Scene) {
        if (Arcs.Preloaded) {
            return;
        }

        let mainConfigFIle = 'configuration/ArcDescriptions.json';
        scene.load.json('arcsJsonData', mainConfigFIle);
        
        Monsters.preload(scene);
        Arcs.Preloaded = true;
    }

    static create(scene) {
        if (Arcs.Created) {
            return;
        }

        Arcs.Arcs = [];
        Monsters.create(scene);

        let arcsData = scene.cache.json.get('arcsJsonData');


        arcsData.Arcs.forEach(jsonArc => {
            let arc: Arc = {
                Name: jsonArc.Name,
                Icon: jsonArc.Icon,
                MapAreaX: jsonArc.MapAreaX,
                MapAreaY: jsonArc.MapAreaY,
                ConfigFolder: jsonArc.ConfigFolder,
                LevelConfigs: jsonArc.LevelConfigs
            };

            // arc.LevelConfigs.forEach(levelConfig => {
            //     let level = Arcs.LoadLevel(scene, levelConfig.ConfigurationFile);
            // });
            Arcs.Arcs.push(arc);
        });
    }

    // static LoadLevel(scene, levelName): Level {

    //     scene.load.json('arcsData', `configuration/arcs/${levelName}`);
    //     let levelConfigJson = scene.cache.json.get('arcsData');

    //     let level: Level = {
    //         Name: levelConfigJson.Name,
    //         Difficulty: levelConfigJson.Difficulty,
    //         GoldEarn: levelConfigJson.GoldEarn,

    //         DurationLimitMinutes: levelConfigJson.DurationLimitMinutes,
    //         StopLevelWhenTimeout: levelConfigJson.StopLevelWhenTimeout,
    //         Generators: []
    //     };
    //     levelConfigJson.Generators.forEach(generatorConfig => {
    //         let mobGeneraotr: IMobGenerate;

    //         if (generatorConfig.Type == "Interval") {

    //             mobGeneraotr = new IntervalMobGenerator();
    //         }
    //         else if (generatorConfig.Type == "OneTime") {
    //             OneTimeMobGenerator
    //         }

    //     });

    /**{
                "Type": "Interval",
                "DurationActiveMinutes": 1,
                "IntervalSpawnSeconds": 5,
                "DelaySecondUntilBegin": 0,
                "IsActive": true,
                "Mobs": ["PracticeHayTarget"]
            }
        }*/
}